<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.elementId"
          outlined
          dense
          :label="mess['dialog_request_field_element_id']"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.customer"
          v-validate="required.customer"
          outlined
          dense
          :label="mess['dialog_request_field_customer_name']"
          :error-messages="errors.collect('customer')"
          data-vv-name="customer"
        />
      </v-col>

      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.author"
          v-validate="required.author"
          outlined
          dense
          :label="mess['dialog_request_field_author_of_application']"
          :error-messages="errors.collect('author')"
          data-vv-name="author"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.address"
          v-validate="required.address"
          outlined
          dense
          :label="mess['dialog_request_field_address']"
          :error-messages="errors.collect('address')"
          data-vv-name="address"
        />
      </v-col>

      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.customerPhone"
          v-validate="required.customerPhone"
          outlined
          dense
          :label="mess['dialog_request_field_customer_phone']"
          :error-messages="errors.collect('customerPhone')"
          data-vv-name="customerPhone"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.customerRepresentative"
          v-validate="required.customerRepresentative"
          outlined
          dense
          :label="mess['dialog_request_field_customer']"
          :error-messages="errors.collect('customerRepresentative')"
          data-vv-name="customerRepresentative"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-menu
          v-model="dateOfSale.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfSale.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfSale"
              v-validate="required.dateOfSale"
              v-on="on"
              :label="mess['dialog_request_field_date_of_sale']"
              :error-messages="errors.collect('dateOfSale')"
              data-vv-name="dateOfSale"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfSale.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfSale.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfSale.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.representativePhone"
          v-validate="required.representativePhone"
          outlined
          dense
          :label="mess['dialog_request_field_phone']"
          :error-messages="errors.collect('representativePhone')"
          data-vv-name="representativePhone"
        />
      </v-col>

      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.specificationNumber"
          v-validate="required.specificationNumber"
          outlined
          dense
          :label="mess['dialog_request_field_specification_number']"
          :error-messages="errors.collect('specificationNumber')"
          data-vv-name="specificationNumber"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-select
          v-model="copyOfForm.request_form"
          v-validate="required.request_form"
          :items="process.params.request_form"
          :label="mess['dialog_request_field_request_form']"
          :error-messages="errors.collect('request_form')"
          item-text="title"
          return-object
          outlined
          dense
          data-vv-name="request_form"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-menu
          v-model="dateOfIncident.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfIncident.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfIncident"
              v-validate="required.dateOfIncident"
              v-on="on"
              :label="mess['dialog_request_field_date_of_incident']"
              :error-messages="errors.collect('dateOfIncident')"
              data-vv-name="dateOfIncident"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfIncident.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfIncident.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfIncident.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-spacer />

    <v-row>
      <h3 class="ma-0 mb-3">
        {{ mess["dialog_request_field_details"] }}
      </h3>
    </v-row>

    <v-row>
      <v-textarea
        v-model="copyOfForm.details"
        v-validate="required.details"
        outlined
        dense
        :label="mess['dialog_request_field_description']"
        :error-messages="errors.collect('details')"
        data-vv-name="details"
      />
    </v-row>

    <v-row>
      <h3 class="ma-0 mb-3">
        {{ mess["dialog_request_field_development"] }}
      </h3>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-menu
          v-model="dateOfInstallation.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfInstallation.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfInstallation"
              v-validate="required.dateOfInstallation"
              v-on="on"
              :label="mess['dialog_request_field_date_of_installation']"
              :error-messages="errors.collect('dateOfInstallation')"
              data-vv-name="dateOfInstallation"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfInstallation.date" no-title scrollable>
            <v-spacer />

            <v-btn
              text
              color="primary"
              @click="dateOfInstallation.close(false)"
            >
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfInstallation.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.plannedOperatingTime"
          v-validate="required.plannedOperatingTime"
          outlined
          dense
          :label="mess['dialog_request_field_planned_operating_time']"
          :error-messages="errors.collect('plannedOperatingTime')"
          data-vv-name="plannedOperatingTime"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.actualOperatingTime"
          v-validate="required.actualOperatingTime"
          outlined
          dense
          :label="mess['dialog_request_field_actual_operating_time']"
          :error-messages="errors.collect('actualOperatingTime')"
          data-vv-name="actualOperatingTime"
        />
      </v-col>
    </v-row>

    <v-row>
      <h3 class="ma-0 mb-3">
      {{ mess["dialog_request_field_equipment_parameters"] }}
    </h3>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.conveyorLength"
          outlined
          dense
          :label="mess['dialog_request_field_conveyor_length']"
          :error-messages="errors.collect('conveyorLength')"
          data-vv-name="conveyorLength"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.tapeDesignation"
          v-validate="required.tapeDesignation"
          outlined
          dense
          :label="mess['dialog_request_field_tape_designation']"
          :error-messages="errors.collect('tapeDesignation')"
          data-vv-name="tapeDesignation"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.tapeSpeed"
          outlined
          dense
          :label="mess['dialog_request_field_tape_speed']"
          :error-messages="errors.collect('tapeSpeed')"
          data-vv-name="tapeSpeed"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.efficiency"
          outlined
          dense
          :label="mess['dialog_request_field_efficiency']"
          :error-messages="errors.collect('efficiency')"
          data-vv-name="efficiency"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.angleOfInclination"
          outlined
          dense
          :label="mess['dialog_request_field_angle_inclination']"
          :error-messages="errors.collect('angleOfInclination')"
          data-vv-name="angleOfInclination"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.materialDensity"
          outlined
          dense
          :label="mess['dialog_request_field_material_density']"
          :error-messages="errors.collect('materialDensity')"
          data-vv-name="materialDensity"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.material"
          outlined
          dense
          :label="mess['dialog_request_field_material_type']"
          :error-messages="errors.collect('material')"
          data-vv-name="material"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.lumpiness"
          outlined
          dense
          :label="mess['dialog_request_field_lumpiness']"
          :error-messages="errors.collect('lumpiness')"
          data-vv-name="lumpiness"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.dropHeight"
          outlined
          dense
          :label="mess['dialog_request_field_dropHeight']"
          :error-messages="errors.collect('dropHeight')"
          data-vv-name="dropHeight"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.minAirTemperature"
          outlined
          dense
          :label="mess['dialog_request_field_min_air_temperature']"
          :error-messages="errors.collect('minAirTemperature')"
          data-vv-name="minAirTemperature"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.materialTemperature"
          outlined
          dense
          :label="mess['dialog_request_field_material_temperature']"
          :error-messages="errors.collect('materialTemperature')"
          data-vv-name="materialTemperature"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.angleRollers"
          outlined
          dense
          :label="mess['dialog_request_field_angle_inclination_rollers']"
          :error-messages="errors.collect('angleRollers')"
          data-vv-name="angleRollers"
        />
      </v-col>
    </v-row>

    <v-row>
      <h3 class="ma-0 mb-3">
        {{ mess["dialog_request_field_drum_diameters"] }}
      </h3>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.diameterDriveDum"
          outlined
          dense
          :label="mess['dialog_request_field_drive_drum']"
          :error-messages="errors.collect('diameterDriveDum')"
          data-vv-name="diameterDriveDum"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.diameterTailDum"
          outlined
          dense
          :label="mess['dialog_request_field_tail_drum']"
          :error-messages="errors.collect('diameterTailDum')"
          data-vv-name="diameterTailDum"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.diameterBypassDum"
          outlined
          dense
          :label="mess['dialog_request_field_bypass_drum']"
          :error-messages="errors.collect('diameterBypassDum')"
          data-vv-name="diameterBypassDum"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-select
        v-model="copyOfForm.tapeDockingType"
        :items="tapeDockingType"
        outlined
        dense
        :label="mess['dialog_request_field_tape_docking_type']"
        :error-messages="errors.collect('tapeDockingType')"
        data-vv-name="tapeDockingType"
      />
    </v-row>
  </v-col>
</template>

<script>
import RequestForm from "@/mixins/RequestForm";

/**
 * @memberOf RequestDialog
 * @name ConveyorsForm
 * @desc Компонент для отрисовки формы "конвейерные ленты"
 *
 * @vue-prop { Object } process - Текущий процесс.
 *
 * @vue-data { Object } [copyOfForm={}] - Данные из полей записываются в эту переменную.
 * @vue-data { requestDialogDatePicker } dateOfSale - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfIncident - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfInstallation - Объект отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 *
 * @vue-computed { String } currentDate - Возвращает текущую дату.
 * @vue-computed { Array } tapeDockingType - Возвращает массив вариантов для select выбора типа стыковой ленты
 *
 * @vue-event initDefaultData - Метод для проставления текущей даты всем объектам используемым для отрисовки datePicker.
 * Это нужно для того чтобы datePicker не был пустым при открытии поп-апа.
 */
export default {
  name: "ConveyorsForm",
  mixins: [RequestForm],
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  inject: ["$validator"],
  data() {
    return {
      copyOfForm: {},
      dateOfSale: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfSale.isOpen = false;
            this.dateOfSale.date = this.copyOfForm.dateOfSale;
          }
        },
        save: () => {
          this.copyOfForm.dateOfSale = this.dateOfSale.date;
          this.dateOfSale.close();
        }
      },
      dateOfIncident: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfIncident.isOpen = false;
            this.dateOfIncident.date = this.copyOfForm.dateOfIncident;
          }
        },
        save: () => {
          this.copyOfForm.dateOfIncident = this.dateOfIncident.date;
          this.dateOfIncident.close();
        }
      },
      dateOfInstallation: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfInstallation.isOpen = false;
            this.dateOfInstallation.date = this.copyOfForm.dateOfInstallation;
          }
        },
        save: () => {
          this.copyOfForm.dateOfInstallation = this.dateOfInstallation.date;
          this.dateOfInstallation.close();
        }
      }
    };
  },
  computed: {
    currentDate() {
      return new Date().toISOString().substr(0, 10);
    },
    errors() {
      return {};
    },
    tapeDockingType() {
      return [
        this.mess["dialog_request_field_docking_type_1"],
        this.mess["dialog_request_field_docking_type_2"],
        this.mess["dialog_request_field_docking_type_3"]
      ];
    }
  },
  mounted() {
    this.initDefaultData();
  },
  methods: {
    initDefaultData() {
      this.copyOfForm.dateOfSale = this.currentDate;
      this.copyOfForm.dateOfIncident = this.currentDate;
      this.copyOfForm.dateOfInstallation = this.currentDate;
    }
  }
};
</script>
